var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"check-proof-transfer","hide-footer":"","hide-header":"","dialog-class":"p-0","body-class":"p-0","centered":""}},[_c('img',{attrs:{"src":_vm.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }